var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-panel', {
    class: _vm.theme.appFooter
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0b1aad12","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/AppFooter/AppFooter.vue
// module id = 1184
// module chunks = 0